import * as api from '../../services/checkinpoint'

export const FETCH_CHECKINPOINTS = 'FETCH_CHECKINPOINTS';
export const FETCH_CHECKINPOINT = 'FETCH_CHECKINPOINT';


export const fetchCheckinpoint = (id) => {
    return {
        type: FETCH_CHECKINPOINT,
        payload: {
            promise: api.findCheckinpoint({id: id})
        }
    }
}


export const fetchCheckinpoints= (params, pagination, sort, extra) => {
    return {
        type: FETCH_CHECKINPOINTS,
        payload: {
            promise: api.findCheckinpoints(Object.assign({}, params, {page: pagination ? pagination.current : 1, pageSize: pagination ? pagination.pageSize : 20})),
        },
        meta: {
            searchParams: params,
            sort: sort,
            extra: extra
        }
    }
}



// WEBPACK FOOTER //
// ./src/redux/actions/checkinpoint.js